import request from '@/utils/request'
/**
 * @apiName 维保入驻审核记录分页列表查询
 * @param  data {pageNum,pageSize,serviceId,collaborationState,auditState,auditContent}
 */
export function collaborationPageList(data = {}) {
  return request({
    url: '/admin/v1/maintenance/collaboration/pageList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 维保入驻审核详情
 * @param data {id:xx}
 */
export function collaborationDetail(data = {}) {
  return request({
    url: '/admin/v1/maintenance/collaboration/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 根据合作ID查询门店列表
 * @param data {id:xx}
 */
export function storeListByCollaborationId(data = {}) {
  return request({
    url: '/admin/v1/maintenance/store/listByCollaborationId',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 门店的使用变更
 * @param data {changeIds:[]}
 */
export function storeUsageChange(data = {}) {
  return request({
    url: '/admin/v1/maintenance/store/usageChange',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 根据合作ID查询项目列表
 * @param data {id}
 */
export function listByCollaborationApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/item/listByCollaborationId',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 项目的使用变更
 * @param data {changeIds:[]}
 */
export function projectUsageChangeApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/item/usageChange',
    method: 'POST',
    data,
  })
}